module.exports = __webpack_public_path__ + "static/media/royaljelly.7d819d6f.png";